import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

interface CreateNewUserStepProperties {
    onCreateUserWithEmail: () => void;
    onCreateUserWithPhone: () => void;
}

export const CreateNewUserStep = memo((props: CreateNewUserStepProperties) => {
    return (
        <div className={'padding-15'}>
            <div className={'padding-15 text-center'}>
                <div className={'text-size-18 line-height-125rel'}>
                    <FormattedMessage id={'intl-msg:user.login.method'} />
                </div>
                <div className={'text-size-12 line-height-125rel'}>
                    <FormattedMessage id={'intl-msg:user.login.selection'} />
                </div>
            </div>
            <div className={'display-flex flex-wrap justify-content-center'}>
                {/** biome-ignore lint/a11y/noStaticElementInteractions: suppress out of convenience during migration to biome */}
                <a
                    className={'btn btn-primary btn-action text-size-20 margin-10'}
                    data-testid={'addUserByEmailBtn'}
                    // biome-ignore lint/a11y/useValidAnchor: suppress out of convenience during migration to biome
                    onClick={props.onCreateUserWithEmail}
                >
                    <span className={'rioglyph rioglyph-envelope'} />
                    <FormattedMessage id={'intl-msg:email'} />
                </a>
                {/** biome-ignore lint/a11y/noStaticElementInteractions: suppress out of convenience during migration to biome */}
                <a
                    className={'btn btn-primary btn-action text-size-20 margin-10'}
                    data-testid={'addUserByPhoneBtn'}
                    // biome-ignore lint/a11y/useValidAnchor: suppress out of convenience during migration to biome
                    onClick={props.onCreateUserWithPhone}
                >
                    <span className={'rioglyph rioglyph-phone'} />
                    <FormattedMessage id={'intl-msg:phoneNumber'} />
                </a>
            </div>
        </div>
    );
});

CreateNewUserStep.displayName = 'CreateNewUserStep';
